import React from 'react';
import { NewsEventsGrid } from './NewsEventsGrid';
import { NewsEventsGridPagination } from './NewsEventsGridPagination';
export const NewsEventsGridWrapper = (props) => {
    const NewsEventsGridComponent = props.isPaginationEnabled
        ? NewsEventsGridPagination
        : NewsEventsGrid;
    return React.createElement(NewsEventsGridComponent, { ...props });
};
